<div class="file-count">
  {{fileCount + (fileCount > 1 ? " RESULTS FOR" : " RESULT FOR")}}
</div>
<div class="search-text">
  {{searchText}}
</div>




